<template>
  <div class="visualization" style="position: relative;">
    <div class="title"></div>
    <img src="../assets/images/zs.png" alt="" style="position: absolute;top: 18px;left: 50px;width: 20px;height: 40px;">
    <div
      style="color: #a6b2bc;font-size: 25px;position: absolute;top: 20px;left: 80px;font-style: italic;font-weight: bold;">
      {{ currentDate }}</div>
    <div
      style="color: #a6b2bc;font-size: 25px;position: absolute;top: 20px;right: 80px;font-style: italic;font-weight: bold;">
      {{ currentTime }}</div>
    <div style="padding: 20px;display: flex; gap: 20px; height: calc(100% - 100px); box-sizing: border-box;">
      <div style="display: flex; flex-direction: column; gap: 20px; height: 100%;">
        <div class="left" style="background: #0d274c;width: 600px;opacity: 0.6; flex: 1 1 auto;">
          <div class="corner-decorations">
            <div class="corner corner-tl"></div>
            <div class="corner corner-tr"></div>
            <div class="corner corner-bl"></div>
            <div class="corner corner-br"></div>
          </div>
          <div>
            <img style="margin-top: 20px;" src="../assets/images/icon1.png" alt="">
          </div>
          <div
            style="display: flex;justify-content: space-between;padding: 0 30px;margin-top: 30px;padding-right: 80px;">
            <div style="position: relative;">
              <img src="../assets/images/icon2.png" alt="">
              <div style="position: absolute;bottom: 20px;right: -30px;color: #b0cbe4;">总数</div>
              <div
                style="position: absolute;bottom: 45px;right: -15px;color: #ffe290;font-size: 22px;font-weight: bold;font-style: italic;">
                {{ obj.total }}</div>
            </div>
            <div style="position: relative;">
              <img src="../assets/images/icon2.png" alt="">
              <div style="position: absolute;bottom: 20px;right: -30px;color: #b0cbe4;">报修</div>
              <div
                style="position: absolute;bottom: 45px;right: -15px;color: #fff;font-size: 22px;font-weight: bold;font-style: italic;">
                0</div>
            </div>
            <div style="position: relative;">
              <img src="../assets/images/icon2.png" alt="">
              <div style="position: absolute;bottom: 20px;right: -30px;color: #b0cbe4;">完好</div>
              <div
                style="position: absolute;bottom: 45px;right: -15px;color: #fff;font-size: 22px;font-weight: bold;font-style: italic;">
                {{ obj.total }}</div>
            </div>
          </div>
          <div>
            <img src="../assets/images/icon3.png" alt=""></img>
          </div>
          <div style="display: flex;flex-wrap: wrap;gap: 10px;padding: 0 30px;">
            <div class="icon10-background icon10">
              <div>
                <img src="../assets/images/icon4.png" alt="">
              </div>
              <div>
                <div style="font-size: 25px;font-weight: bold;color: #fff;font-style: italic;">
                  {{ obj.gw }}
                </div>
                <div style="font-size: 14px;color: #fff;">高温</div>
              </div>
            </div>
            <div class="icon10-background icon10">
              <div>
                <img src="../assets/images/icon5.png" alt="">
              </div>
              <div>
                <div style="font-size: 25px;font-weight: bold;color: #fff;font-style: italic;">{{ obj.my }}</div>
                <div style="font-size: 14px;color: #fff;">满溢</div>
              </div>
            </div>
            <div class="icon10-background icon10">
              <div>
                <img src="../assets/images/icon6.png" alt="">
              </div>
              <div>
                <div style="font-size: 25px;font-weight: bold;color: #fff;font-style: italic;">{{ obj.qd }}</div>
                <div style="font-size: 14px;color: #fff;">倾倒</div>
              </div>
            </div>
            <div class="icon10-background icon10">
              <div>
                <img src="../assets/images/icon7.png" alt="">
              </div>
              <div>
                <div style="font-size: 25px;font-weight: bold;color: #fff;font-style: italic;">0</div>
                <div style="font-size: 14px;color: #fff;">气味</div>
              </div>
            </div>
            <div class="icon10-background icon10">
              <div>
                <img src="../assets/images/icon8.png" alt="">
              </div>
              <div>
                <div style="font-size: 25px;font-weight: bold;color: #fff;font-style: italic;">{{zx }}</div>
                <div style="font-size: 14px;color: #fff;">在线</div>
              </div>
            </div>
            <div class="icon10-background icon10">
              <div>
                <img src="../assets/images/icon9.png" alt="">
              </div>
              <div>
                <div style="font-size: 25px;font-weight: bold;color: #fff;font-style: italic;">{{ lx }}</div>
                <div style="font-size: 14px;color: #fff;">离线</div>
              </div>
            </div>
          </div>
        </div>
        <div class="left" style="background: #0d274c;width: 600px;opacity: 0.6; flex: 0 0 35%;">
          <div class="corner-decorations">
            <div class="corner corner-tl"></div>
            <div class="corner corner-tr"></div>
            <div class="corner corner-bl"></div>
            <div class="corner corner-br"></div>
          </div>
          <div
            style="display: flex; justify-content: space-around; align-items: center; height: calc(100% - 40px); padding: 20px; box-sizing: border-box;">
            <div ref="nitrogenChart" class="chart"></div>
            <div ref="co2Chart" class="chart"></div>
            <div ref="airIndexChart" class="chart"></div>
          </div>
        </div>
      </div>

      <div class="right" style="flex: 1; display: flex; flex-direction: column; height: 100%; min-height: 0;">
        <div class="right-image-container" style="position: relative; flex: 1 1 60%; min-height: 0;">
          <div class="corner-decorations" style="z-index: 10;">
            <div class="corner corner-tl"></div>
            <div class="corner corner-tr"></div>
            <div class="corner corner-bl"></div>
            <div class="corner corner-br"></div>
          </div>
          <div id="container" style="height: 100%;"></div>
          <div
            style="opacity: 0.8; justify-content: center; margin-left: -250px; display: flex; justify-content: space-between; align-items: center; width: 500px; height: 70px;position: absolute;background: #425883;z-index: 100;top: 0;left: 50%;color: #fff;">
            <div style="display: flex;flex-direction: column;align-items: center;flex: 1;">
              <img src="../assets/images/dt1.png" alt="">
              <div>满溢度</div>
            </div>
            <div style="display: flex;flex-direction: column;align-items: center;flex: 1;">
              <img src="../assets/images/dt2.png" alt="">
              <div>气味</div>
            </div>
            <div style="display: flex;flex-direction: column;align-items: center;flex: 1;">
              <img src="../assets/images/dt3.png" alt="">
              <div>倾倒</div>
            </div>
            <div style="display: flex;flex-direction: column;align-items: center;flex: 1;">
              <img src="../assets/images/dt4.png" alt="">
              <div>温度</div>
            </div>
            <div style="display: flex;flex-direction: column;align-items: center;flex: 1;">
              <img src="../assets/images/dt5.png" alt="">
              <div>设备</div>
            </div>
          </div>
          <div v-if="obj.gw > 0 || obj.my > 0 || obj.qd > 0"
            style="padding: 10px 20px; position: absolute;background: #425883;z-index: 100;bottom: 100px;border-radius: 10px; right: 10px;color: #fff;">
            <div style="display: flex;position: relative; margin-top: 10px; background-size: contain;width: 210px;"
              v-for="(item, index) in markers" :key="item.id">
              <img src="../assets/images/3d.png" alt="" sizes="" srcset="">
              <div
                style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
                <div style="margin-left: 30px;display: flex;">
                  <div style="margin-top: 5px;">
                    {{ item.schedulePerson ? item.schedulePerson.nickName : '' }}
                  </div>
                  <div style="font-size: 12px;margin-left: 8px;">
                    <div>
                      编号: {{ item.iemiNumber ? String(item.iemiNumber).slice(-5) : '' }}
                    </div>
                    <div>
                      电话: {{ item.schedulePerson ? item.schedulePerson.phonenumber : '' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 10px;">
          <img src="../assets/images/icon11.png" alt="">
        </div>
        <div class="bar-chart-container"
          style="background: #0d274c;opacity: 0.6;padding: 20px;margin-top: 20px;position: relative; flex: 1 1 40%; min-height: 0;">
          <div class="corner-decorations">
            <div class="corner corner-tl"></div>
            <div class="corner corner-tr"></div>
            <div class="corner corner-bl"></div>
            <div class="corner corner-br"></div>
          </div>
          <div ref="barChart" style="width: 100%; height: 100%;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import request from "@/utils/request";
import axios from 'axios';

// 阈值常量
const FULL_THRESHOLD = 0.7
const TEMP_THRESHOLD = 70

export default {
  name: 'Visualization',
  data() {
    return {
      nitrogenChart: null,
      co2Chart: null,
      airIndexChart: null,
      barChart: null,
      map: null,
      infoWindow: null,
      markerManager: null,
      currentDate: '',
      currentTime: '',
      timeInterval: null,
      users: [],
      zx:0,
      lx:0,
      markerInterval: null,
      markers: [
      ],
      flagF2: false, // F2按键状态
      flagF3: false, // F3按键状态
      flagF4: false, // F4按键状态
      flagF5: false, // F5按键状态
      res: [],
      domOverlays: [],
      obj: {},
      realtimeAqi: {},
      currentOpenMarkerId: null, // 当前打开的弹窗对应的标记点ID
      currentOpenMarkerPosition: null, // 当前打开的弹窗位置
      originalDataF2: null, // 保存F2的原始数据，用于恢复
      originalDataF3: null // 保存F3的原始数据，用于恢复
    }
  },
  async mounted() {
    await this.initMap()
    this.initTime()
    this.startMarkerInterval()
    window.addEventListener('resize', this.handleResize)
    let deptId = this.$route.query.dept
    window.addEventListener('keydown', this.handleGlobalKeydown);
  },
  beforeDestroy() {
    if (this.nitrogenChart) {
      this.nitrogenChart.dispose()
    }
    if (this.co2Chart) {
      this.co2Chart.dispose()
    }
    if (this.airIndexChart) {
      this.airIndexChart.dispose()
    }
    if (this.barChart) {
      this.barChart.dispose()
    }
    if (this.timeInterval) {
      clearInterval(this.timeInterval)
    }
    if (this.markerInterval) {
      clearInterval(this.markerInterval)
    }
    if (this.markerManager) {
      this.markerManager.setMap(null)
    }
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('keydown', this.handleGlobalKeydown)
  },
  methods: {

    // 依据最新 rows 更新统计并返回需要高亮的标记点
    updateStatsFromRows(rows) {
      this.zx = 0
      this.lx = 0
      for (const item of rows) {
        if(item.fullState == null){
          this.lx++
        }else{
          this.zx++
        }
        console.log(this.zx)
      }
      console.log(11111)
      const fullMarkers = rows.filter(item => item.fullState && item.fullState >= FULL_THRESHOLD)
      const tiltMarkers = rows.filter(item => item.equipmentInstallationStatus == 0)
      const tempMarkers = rows.filter(item => item.tmp116 && item.tmp116 >= TEMP_THRESHOLD)
      // 使用 $set 确保响应式更新，或者重新创建对象
      this.$set(this, 'obj', {
        total: rows.length,
        my: fullMarkers.length,
        qd: tiltMarkers.length,
        gw: tempMarkers.length
      })
      const alertMarkers = rows.filter(item => (item.fullState && item.fullState >= FULL_THRESHOLD) || (item.tmp116 && item.tmp116 >= TEMP_THRESHOLD) || item.equipmentInstallationStatus == 0)
      return alertMarkers
    },
    // 用新的 rows 刷新 markers 与弹窗
    refreshMarkersWithRows(res, forceUpdate = false) {
      const rows = res.rows || []
      const newMarkers = this.updateStatsFromRows(rows)

      if (this.currentOpenMarkerId && this.infoWindow) {
        const currentMarker = rows.find(item => String(item.id) === String(this.currentOpenMarkerId))
        if (!currentMarker || !newMarkers.find(m => String(m.id) === String(this.currentOpenMarkerId))) {
          this.infoWindow.close()
          this.currentOpenMarkerId = null
          this.currentOpenMarkerPosition = null
        } else {
          this.updateInfoWindow()
        }
      }
      const markersChanged = JSON.stringify(newMarkers) !== JSON.stringify(this.markers)
      console.log(newMarkers)
      console.log(this.markers)
      this.markers = newMarkers
      // 如果 markers 列表变化或强制更新，则重新渲染
      if (markersChanged || forceUpdate) {
        this.addMarkers(res)
      } else {
        // 即使 markers 列表没变，也要重新渲染图片（因为数据可能变化了）
        this.renderDomOverlays()
      }
    },
    async handleGlobalKeydown(event) {
    let sb = this.$route.query.sb.split(',')
      if (event.key === '1') {
        event.preventDefault()
        if (!this.flagF2) {
          await request.get(`/system/ashcan/high-temp?iemi=${sb[0]}&temp=86`)
          this.flagF2 = true
        } else {
          await request.get(`/system/ashcan/high-temp?iemi=${sb[0]}&temp=23&clean=1`)
          this.flagF2 = false
        }
      } else if (event.key === '2') {
        event.preventDefault()
        if (!this.flagF3) {
          await request.get(`/system/ashcan/high-temp?iemi=${sb[1]}&temp=73`)
          this.flagF3 = true
        } else {
          await request.get(`/system/ashcan/high-temp?iemi=${sb[1]}&temp=23&clean=1`)
          this.flagF3 = false
        }
        console.log('F3 flag:', this.flagF3)
      } else if (event.key === '3') {
        event.preventDefault()
        if (!this.flagF4) {
          await request.get(`/system/ashcan/high-temp?iemi=${sb[2]}&temp=79`)
          this.flagF4 = true
        } else {
          await request.get(`/system/ashcan/high-temp?iemi=${sb[2]}&temp=23&clean=1`)
          this.flagF4 = false
        }
        console.log('F4 flag:', this.flagF4)
      } else if (event.key === '4') {
        event.preventDefault()
        if (!this.flagF5) {
          await request.get(`/system/ashcan/high-temp?iemi=${sb[3]}&temp=82`)
          this.flagF5 = true
        } else {
          await request.get(`/system/ashcan/high-temp?iemi=${sb[3]}&temp=23&clean=1`)
          this.flagF5 = false
        }
        console.log('F5 flag:', this.flagF5)
      } else if (event.key == "Escape") {
        for (const item of sb) {
          await request.get(`/system/ashcan/high-temp?iemi=${item}&clean=1&temp=23`)
        }
      }
      this.startMarkerInterval()
    },
    handleResize() {
      try {
        this.nitrogenChart && this.nitrogenChart.resize()
        this.co2Chart && this.co2Chart.resize()
        this.airIndexChart && this.airIndexChart.resize()
        this.barChart && this.barChart.resize()
        if (this.map && typeof this.map.resize === 'function') {
          this.map.resize()
        }
      } catch (e) { }
    },
    initTime() {
      this.updateTime()
      // 每秒更新时间
      this.timeInterval = setInterval(() => {
        this.updateTime()
      }, 1000)
    },
    updateTime() {
      const now = new Date()
      // 格式化日期 YYYY-MM-DD
      this.currentDate = now.getFullYear() + '-' +
        String(now.getMonth() + 1).padStart(2, '0') + '-' +
        String(now.getDate()).padStart(2, '0')
      // 格式化时间 HH:MM:SS
      this.currentTime = String(now.getHours()).padStart(2, '0') + ':' +
        String(now.getMinutes()).padStart(2, '0') + ':' +
        String(now.getSeconds()).padStart(2, '0')
    },
    startMarkerInterval() {
      // 如果已存在定时器，先清除它，避免重复创建
      if (this.markerInterval) {
        clearInterval(this.markerInterval)
        this.markerInterval = null
      }
      // 每5秒更新一次标记点
      this.markerInterval = setInterval(() => {
        this.updateMarkers()
      }, 5000)
    },
    async updateMarkers() {
      try {
        let deptId = this.$route.query.dept;
        let res = await request.get(`/system/ashcan/list?deptId=${deptId}`)
        this.res = res
        this.refreshMarkersWithRows(res)
      } catch (error) {
        console.error('更新标记点失败:', error)
      }
    },
    async initMap() {
      let deptId = this.$route.query.dept;
      let latitude = 0;
      let longitude = 0;
      let center;
      let res = await request.get(`/system/dept/${deptId}`)
      try{
        await axios.get('https://eolink.o.apispace.com/34324/air/v001/aqi?areacode=101010100', {
        headers: {
          'X-APISpace-Token': '8zhamsnwalwh3jpi17xo1z60ame95h2q'
        }
      })
        .then(res => this.realtimeAqi = res.data.result.realtimeAqi)
      }catch(e){
          this.realtimeAqi = {
            co :0.8,
            no2:29,
            aqi_level:'良好'
          }
      }

      latitude = res.data.latitude
      longitude = res.data.longitude
      this.initCharts()
      center = new TMap.LatLng(latitude, longitude)
      // 地图初始化函数
      // 定义地图中心点坐标
      // latitude
      // longitude
      // 定义map变量，调用 TMap.Map() 构造函数创建地图
      this.map = new TMap.Map(document.getElementById('container'), {
        center: center, // 设置地图中心点坐标
        zoom: 17,     // 设置地图缩放级别
        pitch: 43.5,    // 设置俯仰角
        rotation: 45    // 设置地图旋转角度
      });
      // 详情信息窗体
      this.infoWindow = new TMap.InfoWindow({
        map: this.map,
        position: center,
        content: ''
      });
      this.infoWindow.close();

      // 添加标记点
      let markers = await request.get(`/system/ashcan/list?deptId=${deptId}`)
      this.res = markers
      this.addMarkers(markers)
    },
    async addMarkers(res) {
      // 如果已经存在标记点管理器，先清除
      if (this.markerManager) {
        this.markerManager.setMap(null)
      }

      // 创建标记点
      let deptId = this.$route.query.dept;
      if (!this.markers || this.markers.length === 0) {
        this.markers = this.updateStatsFromRows(res.rows || [])
      }

      const markerList = this.markers.map(marker => {
        return {
          position: new TMap.LatLng(marker.locationLatitude, marker.locationLongitude),
          id: marker.id,
          styleId: 'transparent' // 使用透明样式以避免与自定义覆盖物重复显示
        }
      })

      // 创建标记点管理器
      this.markerManager = new TMap.MultiMarker({
        map: this.map,
        geometries: markerList,
        styles: {
          // 透明样式：保留同尺寸用于点击事件，但不显示图标
          'transparent': new TMap.MarkerStyle({
            width: 32,
            height: 42,
            anchor: { x: 15, y: 25 },
            src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgR8gQxkAAAAASUVORK5CYII='
          }),
        }
      })

      // 使用自定义覆盖物实现跳动动画
      this.renderDomOverlays()

      // 添加点击事件
      this.markerManager.on('click', async (evt) => {
        this.showAshcanInfo(evt.geometry.id, evt.geometry.position)
      })
    },
    // 使用 DOMOverlay 渲染带跳动动画的标记
    renderDomOverlays() {
      // 清理旧的覆盖物
      if (this.domOverlays && this.domOverlays.length) {
        this.domOverlays.forEach(o => {
          try { o.setMap(null) } catch (e) { }
        })
        this.domOverlays = []
      }

      if (!this.map || !this.markers || !this.markers.length) return

      const vm = this
      class BounceOverlay extends TMap.DOMOverlay {
        onInit(options) {
          this.position = options.position
          this.markerId = options.markerId
          this.imgSrc = options.imgSrc
        }
        createDOM() {
          const div = document.createElement('div')
          div.className = 'bounce-marker'
          const img = document.createElement('img')
          img.src = this.imgSrc
          img.style.width = '32px'
          img.style.height = '42px'
          img.style.transformOrigin = 'center bottom'
          div.appendChild(img)
          // 点击跳动图标弹出同样的信息窗
          div.addEventListener('click', () => {
            vm.showAshcanInfo(this.markerId, this.position)
          })
          this.dom = div
          return div
        }
        updateDOM() {
          const pixel = this.map.projectToContainer(this.position)
          this.dom.style.position = 'absolute'
          this.dom.style.left = pixel.getX() + 'px'
          this.dom.style.top = pixel.getY() + 'px'
          this.dom.style.transform = 'translate(-50%, -100%)'
        }
        onDestroy() {
          if (this.dom && this.dom.parentNode) this.dom.parentNode.removeChild(this.dom)
          this.dom = null
        }
        onMapUpdate() {
          this.updateDOM()
        }
      }

      let imgSrc = ''
      this.markers.forEach(m => {
        if (m.tmp116 && m.tmp116 >= 70) {
          imgSrc = require('../assets/images/dt8.png')
        } else if (m.equipmentInstallationStatus == 0) {
          imgSrc = require('../assets/images/dt10.png')
        } else if (m.remainBattery < 0.3) {
          imgSrc = require('../assets/images/dt9.png')
        } else {
          imgSrc = require('../assets/images/dt6.png')
        }

        const overlay = new BounceOverlay({
          map: this.map,
          position: new TMap.LatLng(m.locationLatitude, m.locationLongitude),
          markerId: m.id,
          imgSrc: imgSrc
        })
        this.domOverlays.push(overlay)
      })
    },
    // 生成弹窗内容
    generateInfoContent(markerId) {
      // 直接从轮询更新的列表中根据ID过滤获取数据，实现实时变化
      const d = (this.markers || []).find(m => String(m.id) === String(markerId)) || {}
      const name = d.name || d.ashcanName || `垃圾桶`
      const code = d.iemiNumber || '-'
      const qd = d.equipmentInstallationStatus == 0 ? '倾倒' : '未倾倒'
      const address = (d.locationLatitude || '') + ',' + (d.locationLongitude || '')
      const full = d.fullState != null ? d.fullState : 0
      const fullPct = typeof full === 'number' ? Math.round(full * 100) + '%' : '-'
      const temperature = d.tmp116 != null ? d.tmp116 + '℃' : '-'
      const remainBattery = (d.remainBattery != null ? d.remainBattery * 100 : null)
      const remainBatteryText = (remainBattery != null ? remainBattery + '%' : '-')
      const mq315 = d.mq315 != null ? (d.mq315 < 300 ? '良好' : '污染') : '-'
      return `
                <div style="min-width:220px;max-width:280px;color:#fff;background:#1b2a47;border:1px solid #2f80ed;border-radius:6px;overflow:hidden;">
                    <div style="padding:8px 12px;background:#2b3f6b;font-weight:600;">${name}</div>
                    <div style="padding:10px 12px;line-height:1.6;font-size:12px;">
                        <div><span style="color:#9bb3d7;">编号：</span>${code}</div>
                        <div><span style="color:#9bb3d7;">经纬度：</span>${address}</div>
                        <div><span style="color:#9bb3d7;">满溢度：</span>${fullPct}</div>
                        <div><span style="color:#9bb3d7;">倾倒：</span>${qd}</div>
                        <div><span style="color:#9bb3d7;">温度：</span>${temperature}</div>
                        <div><span style="color:#9bb3d7;">电量：</span>${remainBatteryText}</div>
                        <div><span style="color:#9bb3d7;">空气质量：</span>${mq315}</div>
                    </div>
                </div>`
    },
    // 更新弹窗内容
    updateInfoWindow() {
      if (!this.currentOpenMarkerId || !this.infoWindow || !this.currentOpenMarkerPosition) {
        return
      }
      try {
        const d = (this.markers || []).find(m => String(m.id) === String(this.currentOpenMarkerId))

        // 检查标记点是否还在 markers 列表中，如果不在则关闭弹窗
        if (!d) {
          this.infoWindow.close()
          this.currentOpenMarkerId = null
          this.currentOpenMarkerPosition = null
          return
        }

        const content = this.generateInfoContent(this.currentOpenMarkerId)
        // 更新位置（因为标记点位置可能改变）
        if (d && d.locationLatitude && d.locationLongitude) {
          const newPosition = new TMap.LatLng(d.locationLatitude, d.locationLongitude)
          this.currentOpenMarkerPosition = newPosition
          this.infoWindow.setPosition(newPosition)
        }
        this.infoWindow.setContent(content)
      } catch (e) {
        console.error('更新弹窗内容失败', e)
      }
    },
    showAshcanInfo(markerId, position) {
      try {
        // 保存当前打开的标记点信息
        this.currentOpenMarkerId = markerId
        this.currentOpenMarkerPosition = position

        const content = this.generateInfoContent(markerId)

        if (!this.infoWindow) {
          this.infoWindow = new TMap.InfoWindow({ map: this.map, position, content })
        } else {
          this.infoWindow.setPosition(position)
          this.infoWindow.setContent(content)
        }
        this.infoWindow.open()
      } catch (e) {
        console.error('打开详情失败', e)
      }
    },
    initCharts() {
      this.initNitrogenChart()
      this.initCO2Chart()
      this.initAirIndexChart()
      this.initBarChart()
    },
    initNitrogenChart() {
      this.nitrogenChart = echarts.init(this.$refs.nitrogenChart)
      const option = {
        title: {
          show: true,
          text: 'CO',
          left: 'center',
          top: '55%',
          textStyle: {
            color: '#fff',
            fontSize: 16
          }
        },
        series: [
          {
            type: 'gauge',
            startAngle: 200,
            endAngle: -20,
            min: 0,
            max: 100,
            splitNumber: 10,
            radius: '85%',
            axisLine: {
              lineStyle: {
                width: 15,
                color: [
                  [0.8, '#2c68b3'],
                  [1, 'rgba(255, 255, 255, 0.1)']
                ]
              }
            },
            pointer: {
              itemStyle: {
                color: '#2c68b3'
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            detail: {
              fontSize: 24,
              fontWeight: 'bold',
              color: '#fff',
              offsetCenter: [0, '70%'],
              formatter: '{value}'
            },
            data: [
              {
                value: this.realtimeAqi.co,
              }
            ]
          }
        ]
      };
      this.nitrogenChart.setOption(option)
    },
    initCO2Chart() {
      console.log(this.realtimeAqi)
      this.co2Chart = echarts.init(this.$refs.co2Chart)
      const option = {
        title: {
          show: true,
          text: 'NO₂',
          left: 'center',
          top: '55%',
          textStyle: {
            color: '#fff',
            fontSize: 16
          }
        },
        series: [
          {
            type: 'gauge',
            startAngle: 200,
            endAngle: -20,
            min: 0,
            max: 1000,
            splitNumber: 10,
            radius: '85%',
            axisLine: {
              lineStyle: {
                width: 15,
                color: [
                  [0.4, '#3fbd63'],
                  [1, 'rgba(255, 255, 255, 0.1)']
                ]
              }
            },
            pointer: {
              itemStyle: {
                color: '#3fbd63'
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            detail: {
              fontSize: 24,
              fontWeight: 'bold',
              color: '#fff',
              offsetCenter: [0, '70%'],
              formatter: '{value}'
            },
            data: [
              {
                value: this.realtimeAqi.no2,
              }
            ]
          }
        ]
      };
      this.co2Chart.setOption(option)
    },
    initAirIndexChart() {
      this.airIndexChart = echarts.init(this.$refs.airIndexChart)
      const option = {
        title: {
          show: true,
          text: '空气质量指数',
          left: 'center',
          top: '55%',
          textStyle: {
            color: '#fff',
            fontSize: 16
          }
        },
        series: [
          {
            type: 'gauge',
            startAngle: 200,
            endAngle: -20,
            min: 0,
            max: 100,
            splitNumber: 10,
            radius: '85%',
            axisLine: {
              lineStyle: {
                width: 15,
                color: [
                  [0.6, '#f1bb7a'],
                  [1, 'rgba(255, 255, 255, 0.1)']
                ]
              }
            },
            pointer: {
              itemStyle: {
                color: '#f1bb7a'
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            detail: {
              fontSize: 24,
              fontWeight: 'bold',
              color: '#fff',
              offsetCenter: [0, '70%'],
              formatter: () => this.realtimeAqi.aqi_level
            },
            data: [
              {
                value: 60,
              }
            ]
          }
        ]
      };
      this.airIndexChart.setOption(option)
    },
    initBarChart() {
      this.barChart = echarts.init(this.$refs.barChart)
      const option = {
        xAxis: {
          type: 'category',
          data: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
          axisLabel: {
            color: '#b0cbe4',
            fontSize: 12
          },
          axisLine: {
            lineStyle: {
              color: '#b0cbe4'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#b0cbe4',
            fontSize: 12
          },
          axisLine: {
            lineStyle: {
              color: '#b0cbe4'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#1a3a5c'
            }
          }
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130, 120, 200, 150],
            type: 'bar',
            itemStyle: {
              color: '#30abe3'
            }
          }
        ]
      };
      this.barChart.setOption(option)
    }
  }
}
</script>
<style lang="less" scoped>
.visualization {
  width: 100%;
  height: 100%;
  background: url('../assets/images/bg.jpg') no-repeat center center;
  color: red;

  .title {
    width: 100vw;
    height: 100px;
    background: url('../assets/images/title.png') no-repeat center center;
  }

  .left,
  .right-image-container,
  .bar-chart-container {
    position: relative;

    .corner-decorations {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      pointer-events: none;

      .corner {
        position: absolute;
        width: 20px;
        height: 20px;
        border: 2px solid #00ffff;

        &.corner-tl {
          top: 0;
          left: 0;
          border-right: none;
          border-bottom: none;
        }

        &.corner-tr {
          top: 0;
          right: 0;
          border-left: none;
          border-bottom: none;
        }

        &.corner-bl {
          bottom: 0;
          left: 0;
          border-right: none;
          border-top: none;
        }

        &.corner-br {
          bottom: 0;
          right: 0;
          border-left: none;
          border-top: none;
        }
      }
    }
  }

  .icon10-background {
    width: 170px;
    height: 100px;
    background: url('../assets/images/icon10.png') no-repeat center center;
    background-size: contain;
    /* 确保图片完整显示 */
  }

  .icon10 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

  .chart {
    flex: 1 1 0;
    height: 100%;
    min-width: 0;
  }

  // ECharts 图表样式
  .echarts-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 200px;
    padding: 20px;
  }

  .chart-item {
    width: 150px;
    height: 150px;
    position: relative;
  }

  // 地图标记点跳动动画
  @keyframes bounce {

    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }

    40% {
      transform: translateY(-8px);
    }

    60% {
      transform: translateY(-4px);
    }
  }

  // 深度作用到地图中的 DOM 覆盖物
  ::v-deep #container .bounce-marker {
    position: absolute;
    will-change: transform;
    pointer-events: auto;
  }

  ::v-deep #container .bounce-marker img {
    animation: bounce 2s infinite;
    transform-origin: center bottom;
    display: block;
  }
}
</style>